import Box from "@mui/material/Box";
import { IObservationByRegion } from "store/dashboard/observationsByRegion/initialState";
import RegionNoData from "../../imgs/RegionNoData";
import { useSelector } from "react-redux";
import LinearProgressWithLabelAndCount from "../../LinearProgressWithLabel";

interface IRegionsObservationsLinearProgress {
  data: IObservationByRegion[];
}

const RegionsObservationsLinearProgress = (
  props: IRegionsObservationsLinearProgress
) => {
  const observationRegions = useSelector(
    (state: any) => state.dashboard.observationsByRegion
  );

  return (
    <div className="overflow-y-auto h-full pr-1">
      <Box height={"100%"}>
        {props.data.length > 0 ? (
          props.data.map((item: any, index: number) => {
            const highlightedFeatureId =
              observationRegions?.highLightedData?.mapData?.features?.[0]?.id;

            const isMatched =
              item?.mapData?.features?.[0]?.id === highlightedFeatureId;

            return (
              <Box
                sx={{
                  flexGrow: 1,
                  mb: 1,
                  border: isMatched
                    ? `2px solid ${observationRegions?.highLightedData?.color}`
                    : ` white`,
                  // backgroundColor: isMatched ? "black" : "transparent",
                  borderRadius: "8px",
                  padding: "8px",
                  transition: "background-color 0.3s ease",
                  "&:not(:last-child)": { mb: "15px" },
                }}
                key={index}
              >
                <LinearProgressWithLabelAndCount
                  label={item.regionName || "N/A"}
                  value={item.count}
                  barColor={item.color}
                />
              </Box>
            );
          })
        ) : (
          <div className="flex items-center justify-center w-full h-full">
            <RegionNoData />
          </div>
        )}
      </Box>
    </div>
  );
};

export default RegionsObservationsLinearProgress;
